var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemovefavorites({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9752 2.66277C11.1872 1.56611 9.62657 2.00811 8.68924 2.71211C8.30524 3.00077 8.11324 3.14544 7.99991 3.14544C7.88657 3.14544 7.69457 3.00077 7.31057 2.71211C6.37324 2.00811 4.81257 1.56611 3.02457 2.66277C0.678573 4.10211 0.147906 8.84944 5.55991 12.8561C6.59057 13.6181 7.10591 14.0001 7.99991 14.0001C8.89391 14.0001 9.40924 13.6188 10.4399 12.8554C15.8519 8.85011 15.3212 4.10211 12.9752 2.66277Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemovefavorites);
export default __webpack_public_path__ + "static/media/removefavorites.785507535ab34e1f5eda2e94b04b228c.svg";
export { ForwardRef as ReactComponent };